import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

import { ScheduleBlockItem } from '@/tools/models/class-builder.models';

@Component({
  name: 'ed-block-item',
})
export default class EdBlockItemComponent extends Vue {
  @Prop({ default: null }) readonly block: any;
  @Prop({ default: '' }) readonly label: string;
  @Prop({ default: '' }) readonly subLabel: string;
  @Prop({ default: false }) readonly hasEditionOptions: boolean;
  @Prop({ required: true }) readonly isAbleToModify: boolean;
  @Prop({ default: false }) readonly capitalizeLabel: boolean;

  get labelText() {
    return this.capitalizeLabel ? this.label.toLocaleLowerCase() : this.label;
  }

  @Emit('onEditBlockSelected')
  emitOnEditBlockSelected() {
    return this.block;
  }

  @Emit('onDeleteBlockSelected')
  emitOnDeleteBlockSelected() {
    return this.block;
  }
}